import React from 'react';
import {useMemo} from "react";
import ChatDrawerAvatar from "@iso/components/ChatDrawer/ChatDrawerAvatar";

const LIST_AVATAR_COLORS = ['#DFC27E', '#F6E8C3', '#F5F5F5', '#C7EAE6', '#81CDC1', '#369790'];
const getRandom = (arr) => arr[Math.floor(Math.random() * arr.length)];

const ChatDrawerAvatarGroup = ({ items, defaultProfile }) => {
  const avatars = useMemo(() => {
    if (items && items.length > 3) {
      return items.slice(-3);
    }

    return items;
  }, [items]);

  if (avatars && avatars.length === 1) {
    return (
      <div className='flex w-[50px] justify-center'>
        {
          avatars.map((avatar, index) => (
            <ChatDrawerAvatar
              key={index}
              fullName={avatar.fullName}
              avatarURL={avatar.avatarURL}
            />
          ))
        }
      </div>
    )
  }

  if ((!avatars || avatars.length === 0) && defaultProfile) {
    return (
      <div className='flex w-[50px] justify-center'>
        <ChatDrawerAvatar
          key={defaultProfile?.code}
          fullName={defaultProfile?.fullName}
        />
      </div>
    )
  }

  return (
    <div className='flex flex-col w-65'>
      <div className='flex justify-end'>
        {avatars &&
          avatars.length > 2 &&
          avatars
            .slice(0, 2)
            .map((avatar, index) => (
              <ChatDrawerAvatar
                key={index}
                fullName={avatar.fullName}
                avatarURL={avatar.avatarURL}
                classes={'border-2 border-white'}
              />
            ))}

        {avatars &&
          avatars.length < 3 &&
          avatars.slice(0, 1).map((avatar, index) => (
            <ChatDrawerAvatar
              key={index}
              fullName={avatar.fullName}
              avatarURL={avatar.avatarURL}
              classes={'border-2 border-white'}
            />
          ))}
      </div>
      {avatars && avatars.length > 1 && (
        <div className='flex justify-center mt-[-10px] ml-[10px]'>
          {avatars.slice(-1).map((avatar, index) => (
            <ChatDrawerAvatar
              key={index}
              fullName={avatar.fullName}
              avatarURL={avatar.avatarURL}
              classes={'border-2 border-white'}
            />
          ))}
        </div>
      )}
    </div>
  );
}

export default ChatDrawerAvatarGroup;